import { useEffect } from 'react';
import {CostsComponent, configureCostsAuth, authEvents} from '@umd-dit/cost-component-react';
import '@umd-dit/cost-component-react/style.css';
import { addAuthHeaders } from '@umd-dit/oidc-core';
import { useAuth } from '@/context/AuthContext';
import { SERVICE_TYPE_CONFIGS } from '@/types/services';

export default function Costs() {
  const { selectedOrganizationId, selectedWorkspaceId, isAdmin } = useAuth();

  console.log('[Costs] Component rendering with:', {
    selectedOrganizationId,
    selectedWorkspaceId,
    isAdmin
  });

  // Configure the cost component with the addAuthHeaders from OIDC core
  useEffect(() => {
    try {
      // Check if addAuthHeaders is available
      if (typeof addAuthHeaders !== 'function') {
        throw new Error('addAuthHeaders from OIDC core is not available');
      }
      
      // Pass the addAuthHeaders function to the cost component
      configureCostsAuth(addAuthHeaders);
      console.log('Cost component configured with legislative-review auth mechanism');
      
      // Subscribe to auth error events from the cost component
      const unsubscribe = authEvents.onAuthError((event) => {
        console.warn('Auth error received in parent component:', event);
        // You could redirect to login page or trigger OIDC re-authentication here
      });
      
      // Clean up the subscription when component unmounts
      return () => {
        unsubscribe();
      };
    } catch (error) {
      console.error('Error configuring costs auth:', error);
      // Display an error message to the user
      alert('Failed to initialize costs component. Authentication configuration error.');
    }
  }, []); // No dependencies since addAuthHeaders is imported directly

  // Don't render the costs component until we have a workspace selected
  if (!selectedOrganizationId || !selectedWorkspaceId) {
    return (
      <div className="container mx-auto px-4 py-4">
        <div className="text-center py-8">
          <p className="text-gray-600">Please select a workspace to view costs.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-4">      
      {/* React component using centralized service configuration */}
      <CostsComponent
        appId="legislative-review"
        costsApiUrl={import.meta.env.VITE_COSTS_API_URL}
        organizationId={selectedOrganizationId}
        workspaceId={selectedWorkspaceId}
        defaultCostView="workspace"
        isAdmin={isAdmin}
        serviceTypeConfigs={SERVICE_TYPE_CONFIGS}
      />
    </div>
  );
}